

<div class=" profile">



    <div class="row">
        <div class="profile-photo col-md-12">
            <img src="../../../assets/sakshi_profile_pic.png" class="avatar img-circle img-thumbnail" alt="avatar">
        </div>    
    </div>

    <div class="profile-info">

    <hr>
        <div class="row">
            <div class="col-md-12">
                Assistant Professor of Economics
                
            </div>
            
        </div>
        <hr>
        <div class="row">
            <div class="col-md-12">
                University of Wisconsin-Whitewater       
            </div>
            
        </div>
<hr>
        <div class="row">
            <div class="col-md-12">
                <a href="mailto:bhardwas@uww.edu">bhardwas@uww.edu</a>
            </div>
            
        </div>
        <hr>
        <div class="row">
            <div class="col-md-12">
                <a href="../../../assets/Bhardwaj_Sakshi_CV.pdf" target="_blank">CV</a>
            </div>
            
        </div>
        <hr>

    </div>

    <div class="social-media">
        <div class="social-media-item">
        
            <i class="fab fa-linkedin fa-2x" aria-hidden="true" style="color: #0e76a8;">
            
            </i>
    
        <div class="p-2">
            <a href="https://www.linkedin.com/in/sakshi-bhardwaj-b43a9535/"
             target="_blank">
             LinkedIn
            </a> 
            
        </div>
    </div>

    <!-- <div class="social-media-item">
      
        <i class="fab fa-github-square fa-2x" style="color: #211F1F;"></i>
 
    <div class="p-2">
        <a href="https://github.com/ankyAgrawal"
         target="_blank">
         Github
        </a> 
        
    </div>
</div> -->

        <div class="social-media-item">
       
            <i class="icon ai ai-google-scholar-square  ai-2x" style="color: #4285f4;"></i>
       
        <div class="p-2">
            <a href="https://scholar.google.com/citations?hl=en&user=PZ-PxsMAAAAJ&view_op=list_works&sortby=pubdate"
             target="_blank">
             Google Scholar
            </a> 
        </div>
    </div>
    
    <div class="social-media-item">
       
            <i class=" fab fa-twitter-square fa-2x" style="color: #00acee;"></i>
       
        <div class="p-2">
            <a href="https://twitter.com/Sakshi_Econ"
             target="_blank">
             Twitter
            </a> 
        </div>
       
    </div>
    
    <div class="social-media-item">
       
            <i class="fab fa-square-bluesky fa-2x" style="color: lightblue;"></i>
      
        <div class="p-2">
            <a href="https://bsky.app/profile/sakshibhardwaj.bsky.social"
             target="_blank">
             BlueSky
            </a> 
            
        </div>
    </div>

   
    </div>
 
</div>
